export default "__VITE_ASSET__663af807__"